import ScrollList from "./scrollList";
export type ScrollListInstance = InstanceType<typeof ScrollList>;
export default ScrollList;
